<script setup>

defineProps(['x', 'y', 'visible']);

function ignoreClick (e) {
  e.preventDefault();
  e.stopPropagation();
}

</script>

<template>
    <div v-if="visible" class="context-menu" :style="{
      'left': (x * 100) + '%',
      'top': (y * 100) + '%',
    }" @click="ignoreClick" @contextmenu="ignoreClick"><slot>No Menu</slot></div>
</template>

<style scoped>
  .context-menu {
    position: absolute;
    background-color: #e0e0e0;
    padding: 0.5em 0;
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.5) 6px 4px 8px -1px;
    pointer-events: all;
    overflow: hidden;
  }
</style>
